import React from "react";

import FormattedMessage from "@components/UI/FormattedMessage";

export function FilterRangeDescription(props: {
  translationId: string;
  rangeId: string;
  children: string;
}) {
  return (
    <div className="filters-range-description">
      <b>
        <FormattedMessage id={props.translationId} />:{" "}
        <span style={{ float: "right" }} id={props.rangeId}>
          {props.children}{" "}
        </span>
      </b>
    </div>
  );
}
